import React from 'react';
import { CheckIcon, DumbbellIcon, FileTextIcon, TargetIcon, UsersIcon } from 'lucide-react';
import { coverageTags, readyStats } from '../data/content';
const icons = {
  file: FileTextIcon,
  dumbbell: DumbbellIcon,
  target: TargetIcon,
  users: UsersIcon
};
export function NetballReadyStats() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-160" data-mp="3bnpgn9hvxz46">
      <div className="mx-auto w-full max-w-5xl" data-id="element-161" data-mp="36p4h7cagjjgs">
        <div className="flex justify-center" data-id="element-162" data-mp="36qz06l2651i8">
          <p className="rounded-full bg-[#0a0a0a] px-5 py-2.5 text-center text-[11px] font-bold uppercase tracking-wide text-white sm:text-xs" data-id="element-163" data-mp="31yxujhzia916">
            🏆 The complete system to stop improvising netball training
          </p>
        </div>

        <h2 className="mt-8 text-center text-4xl font-extrabold uppercase tracking-tight text-neutral-900 sm:text-5xl" data-id="element-164" data-mp="2szauaziij99p">
          Netball <span className="text-[#6d28d9]" data-id="element-165" data-mp="2o0zkgos7wyrh">Ready™</span>
        </h2>

        <p className="mt-4 text-center text-sm font-bold uppercase tracking-widest text-[#6d28d9]" data-id="element-166" data-mp="2j14tkl8g096f">
          — 6 Volumes + 5 Bonuses —
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-neutral-700" data-id="element-167" data-mp="22otwi5dkez3l">
          Over 180 pages. 200+ professional sessions. 101 drills. Tactics. Physical
          Preparation. Team Management.{' '}
          <strong className="font-extrabold text-neutral-900" data-id="element-168" data-mp="1txl5xgxr4ofo">Everything ready.</strong>
        </p>

        <div className="mt-10 grid grid-cols-2 gap-5 md:grid-cols-4" data-id="element-169" data-mp="2hn5po21qbpq0">
          {readyStats.map(stat => {
          const Icon = icons[stat.icon as keyof typeof icons];
          return <div key={stat.label} className="rounded-2xl border border-neutral-200 bg-neutral-50 px-4 py-7 text-center" data-id="element-170" data-mp="27mvc2gbs8gab">
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-[#ede9fe]" data-id="element-171" data-mp="w91b76ljdff6">
                  <Icon className="h-5 w-5 text-[#6d28d9]" aria-hidden="true" data-id="element-172" data-mp="118dxnq8hwkh8" />
                </span>
                <p className="mt-4 text-3xl font-extrabold tracking-tight text-neutral-900" data-id="element-173" data-mp="h69pedkvu7yf">
                  {stat.value}
                </p>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-neutral-600" data-id="element-174" data-mp="d4y4glcyeawk">
                  {stat.label}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-10 rounded-2xl border border-neutral-200 bg-neutral-50 px-5 py-8" data-id="element-175" data-mp="3c8vpy8sfb4x">
          <p className="text-center text-xs font-bold uppercase tracking-widest text-neutral-900" data-id="element-176" data-mp="3uijpd9bgx9m8">
            Full coverage, every category
          </p>
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-177" data-mp="3lj6imoeqaz57">
            {coverageTags.map(tag => <li key={tag} className="flex items-center gap-2 rounded-full border border-neutral-200 bg-white px-4 py-2 text-sm font-bold text-neutral-900" data-id="element-178" data-mp="3gmg25zz0i1j9">
                <CheckIcon className="h-4 w-4 text-[#00c853]" aria-hidden="true" data-id="element-179" data-mp="1eu9xwv0f06f3" />
                {tag}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}